import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { PartTimeJob } from '../api/part-time-job/type';
import { BookmarkButton } from './BookmarkButton';
import { Icon } from './Icon';

interface LikeCardProps {
  partTimeJob: PartTimeJob;
}
export const LikeCard: FC<LikeCardProps> = ({ partTimeJob }) => {
  const navigate = useNavigate();
  const {
    title,
    hourPay,
    company: { companyName, address },
  } = partTimeJob;

  if (!partTimeJob) {
    return <></>;
  }

  return (
    <div onClick={() => navigate(`/part-time-job/${partTimeJob.id}`)}>
      <img
        className="aspect-[5/3] w-full rounded-md object-cover"
        src={partTimeJob.mainImgUrl}
        crossOrigin="anonymous"
        alt=""
      />
      <div>
        <div className="mt-6 flex justify-between space-x-3">
          <div className="space-y-1">
            <h6 className="line-clamp-2">{title}</h6>
            <p className="teat-gray-700 text-14 font-medium">{companyName}</p>
          </div>
          <BookmarkButton
            partTimeJobId={partTimeJob.id}
            isLike={true}
            isLogin={true}
          />
        </div>
        <h5 className="mt-4 font-bold">시급 {hourPay.toLocaleString()}원</h5>
        <div className="mt-2">
          <div className="flex w-max max-w-full items-center space-x-1 rounded-md bg-sub-2 p-2">
            <Icon.MapPin className="wh-4 flex-none  text-brand-1" />
            <p className="truncate text-13 font-medium ">{address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
